import React from 'react'
import { Container } from 'react-bootstrap'
import styled from 'styled-components'
import Title from './shared/Title'
import { VictoryPie, VictoryLabel } from 'victory'

import { media } from './util/media-queries'

const Content = styled(Container)`
  display: flex;
  align-items: center;
  max-width: 950px;
  ${media.mobile`
    flex-direction: column-reverse;
    padding: 0 40px;
  `}
  ${media.tablet`
    padding: 0;
    flex-direction: row;
  `}
`

const ChartContainer = styled.div`
  ${media.mobile`
    width: 100%;
    margin: -10px 75px 0 75px;
  `}
  ${media.tablet`
    width: 55%;
    margin: -36px 50px 0 50px;
  `}
`

const FundraisingChart = () => {
  const raised = 15936
  const target = 12500
  const remaining = target - raised

  return (
    <svg viewBox="0 0 400 400">
      <VictoryPie
        standalone={false}
        width={400}
        height={400}
        data={[
          { x: '$12,500 goal', y: raised },
          { x: ' ', y: remaining },
        ]}
        innerRadius={70}
        labelRadius={97}
        style={{
          labels: {
            fontFamily: "'Montserrat', sans-serif",
            fontSize: 16,
            fill: '#fff',
            border: '1px solid #000000',
            fontWeight: 500,
          },
        }}
        colorScale={['#1EBBD7', '#f9f9f9']}
      />
      <VictoryLabel
        textAnchor="middle"
        style={{
          fontFamily: "'Abril Fatface', sans-serif",
          fontSize: 64,
          fill: '#fff',
          whiteSpace: 'pre-line'
        }}
        x={200}
        y={200}
        text={`$${raised.toLocaleString()}\nRaised`}
      />
    </svg>
  )
}

const Footer = () => {
  const hikeDate = new Date('2021-07-31')
  const remainingDays = Math.floor(
    (hikeDate - new Date()) / (1000 * 60 * 60 * 24)
  )

  return (
    <section id="donate">
      <Content>
        <ChartContainer>
          <FundraisingChart />
        </ChartContainer>
        <div>
          <Title id="footer-title" title="Help me reach my goal" />
          <div className="project-wrapper">
            <p id="footer-copy" className="project-wrapper__text ">
              You can support the{' '}
              <span style={{ fontWeight: 700 }}>American Cancer Society</span>{' '}
              and help me reach my{' '}
              <span style={{ fontWeight: 700 }}>$12,500</span> fundraising goal
              at my personal donation page:
            </p>
            <br />
          </div>
          <p className="project-wrapper__text">
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="cta-btn cta-btn--resume"
              href="https://secure.acsevents.org/site/SPageServer?pagename=active_donate_now&PROXY_TYPE=20&PROXY_ID=42479592&FR_ID=97733&fr_id=97733"
              style={{ minWidth: 225, textTransform: 'uppercase' }}>
              Donate Here
            </a>
          </p>
        </div>
      </Content>
    </section>
  )
}

export default Footer
